import { apiGet, apiPost, apiPut, apiPatch } from "./apiUtils";
import { storeSet } from "./storeUtils";
import { BILLSBY_ADMIN_AUTH_DATA_CONTROL } from "./constants";
import { reduxStore } from "..";
import { initAuthData } from "../actions/authActions";
import history from "./history";
import { login } from "./authUtils";
import { IIntercomSettings } from "../models/Intercom";

class API {
  static loginUser(email: string, password: string, code2fa?: string) {
    return login(email, password, code2fa);
  }

  static sendLoginCodeViaSMS(data: { email: string, password: string }) {
    return apiPost("token/sms", data);
  }

  static authEndpoint(companyDomain: string) {
    return apiGet(`api/admin/v1/${companyDomain}/users`);
  }
  
  static fetchUsers(pageNr: number, pageSize: number, search: string = '', includeAll: boolean = true) {
    return apiGet(`api/admin/v1/users?page=${pageNr}&pageSize=${pageSize}&search=${search}&includeAll=${includeAll}`);
  }
  
  static fetchCompanies(pageNr: number, pageSize: number, search: string = '') {
    return apiGet(`api/admin/v1/companies?page=${pageNr}&pageSize=${pageSize}&search=${search}`);
  }

  static updatehUser2fa(userId: number) {
    return apiPut(`api/admin/v1/users/${userId}/2fa`, {});
  }
  
  static fetchIntercomSettings() {
    return apiGet("api/admin/v1/systemSettings");
  }

  static updateIntercomSettings(payload: IIntercomSettings) {
    return apiPut("api/admin/v1/systemSettings", payload);
  }

  static fetchUserToken(userId: number, isForceAccess: boolean) {
    return apiGet(`api/admin/v1/users/${userId}/impersonate?force-access=${isForceAccess}`);
  }

  static updateCancellationDate(companyId: number, dateTimeToSet: Date) {
    return apiPut(`api/admin/v1/companies/deletionDate`, {
      companyId,
      dateTimeToSet
    });
  }
}

export default API;